import BaseLayout from '@/components/BaseLayout';
import Home from './home';
import Home2 from './home2';
import Login from './login';
import Knowledge from './knowledge';
import Model from './model';
import ModelConfigList from './modelConfig';
import PromptTemplateList from './prompt';
import SkillRegistryList from './skill';
import KnowledgeBaseList from './knowledgeBase';
import AgentConfigList from './agent';
import TenantAuthList from './tenantAuth';
import UserList from './user';
import ApplicationAuthList from './applicationAuth';
import { Navigate } from 'react-router-dom';
import ConversationList from './conversation';
import ApplicationList from './application';
import Workflow from './workflow';
import McpServerList from './mcpServer';

const dashboardRoutes = [
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/home2',
    element: <Home2 />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      { index: true, element: <Navigate to="/modelConfigList" /> },
      { path: '/modelConfigList', element: <ModelConfigList /> },
      { path: '/promptList', element: <PromptTemplateList /> },
      { path: '/skillList', element: <SkillRegistryList /> },
      { path: '/knowledgeBaseList', element: <KnowledgeBaseList /> },
      { path: '/agentList', element: <AgentConfigList /> },
      { path: '/tenantAuthList', element: <TenantAuthList /> },
      { path: '/knowledgeList', element: <Knowledge /> },
      { path: '/modelList', element: <Model /> },
      { path: '/userList', element: <UserList /> },
      { path: '/authList', element: <ApplicationAuthList /> },
      { path: '/conversationList', element: <ConversationList /> },
      { path: '/applicationList', element: <ApplicationList /> },
      { path: '/applicationList/edit/:id', element: <Workflow /> },
      { path: '/mcpServerList', element: <McpServerList /> },
    ],
  },
  { path: '*', element: <div>404 Not Found</div> },
];
export default dashboardRoutes;
